<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    showBack: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    shouldShowBack() {
      if (this.showBack !== null) return this.showBack
      return this.items && this.items.length > 1 && this.items.some((i) => i.href)
    },
    backTarget() {
      if (!this.items || this.items.length < 2) return null
      const withHref = this.items.filter((i) => i.href && !i.active)
      return withHref.length > 0 ? withHref[withHref.length - 1].href : null
    },
  },
  methods: {
    goBack() {
      if (this.backTarget) {
        this.$router.push(this.backTarget)
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <el-button
            v-if="shouldShowBack"
            type="text"
            icon="el-icon-arrow-left"
            class="page-header-back mr-2"
            @click="goBack"
          >
            返回
          </el-button>
          <h4 class="mb-0">{{ title }}</h4>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<style scoped>
.page-header-back {
  padding: 4px 8px;
  margin-right: 4px;
  color: #6b7280;
}
.page-header-back:hover {
  color: #2d6cdf;
}
</style>
